
import { StoresStore } from "@/store/modules/Warehouse/Warehouse";
import { WorkersStore } from "@/store/modules/Workers";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { FormMix } from "@/UI/mixins/FormMix";
import { mixins } from "vue-class-component";
import { WorkersMix } from "@/UI/mixins/Store/WorkersMix";
import { StoreMix } from "@/UI/mixins/Store/StoreMix";
import { ProductsMix } from "@/UI/mixins/Store/ProductsMix";
import { FormRules, SaleProductData, SaleProductFormData } from "@/form/Warehouse/Operations/SaleProductFormData";
import { Col, DatePicker, FormModel, Input, message, Row, Select } from "ant-design-vue";
import { FormLayoutMix } from "@/UI/mixins/Layouts/Form";
import { OperationsMix } from "@/UI/mixins/Store/OperationsMix";
import { HandleScrollStore, ScrollData, SearchData, SearchinStore } from "@/UI/Decorators/decorator";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import moment from "moment";
import { CancelMix } from "@/UI/pages/Stores/Mixins/CancelMix";
import { ProductsStockMix } from "@/UI/mixins/Store/ProductsStockMix";
import { CashBoxMix } from "@/UI/mixins/CashBoxMix";
import { CashboxStore } from "@/store/modules/Finance/Cashbox";
import { CounterpartiesStore } from "@/store/modules/Counterparties";
import { CounterpartiesMix } from "@/UI/mixins/CounterpartiesMix";
import { ClientsMix } from "@/UI/mixins/ClientsMix";
import { ClientsStore } from "@/store/modules/Clients";
import { getStudioId } from "@/UI/lib/state";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
import { OperationsStore } from "@/store/modules/Warehouse/Operations";
import { DataEntity, Operations, ProductsOperationEntity } from "@/entity/warehouse/Operations/Operations.types";
import { DataEntityStock, ProductsStock } from "@/entity/warehouse/Products/ProductsStock.types";
import { HideOnScrollMix } from "@/UI/mixins/Calendar/HideOnScrollMix";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";

@Component({
  components: {
    BaseDataForm,
    ModalWrapper,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-col": Col,
    "a-row": Row,
    "a-date-picker": DatePicker,
    "a-textarea": Input.TextArea,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
  },
  methods: { moment },
})
export default class ProductsOperations extends mixins(
  FormMix,
  WorkersMix,
  StoreMix,
  ProductsMix,
  OperationsMix,
  FormLayoutMix,
  PaginationMix,
  CancelMix,
  ProductsStockMix,
  CashBoxMix,
  CounterpartiesMix,
  HideOnScrollMix,
  ClientsMix,
) {
  @Prop() forms!: SaleProductFormData;
  showStockProducts = false;
  rules = FormRules
  stockProducts: ProductsStock | null = null;
  preloadedProducts: DataEntityStock[] = [];
  t_mod: boolean = false
  tree_keys = [];
  handleModal(): void {
    this.showStockProducts = false;
  }
  public addProductsFromList(): void {
    this.showStockProducts = true;
  }

  async addClientData(value: any, option: any): Promise<void> {
    const key = Number((option["data"]["key"] as string).replace("cl-", ""));
    this.forms.client_name = key as any
    await ClientsStore.fetchData({ filter: { id: key } })

    if (this.client) {
      this.forms.client_name = this.client["name"];
      this.forms.client_phone = this.client["phone"];
    }
  }

  datee(value: string) {
    if (this.forms.date) {
      return moment(value, 'DD.MM.YYYY')
    } else {
      this.forms.date = ''; // если ставить просто '', то пикер удаляется из DOM
    }
  }

  timee(value: string) {
    if (this.forms.time) {
      if (this.forms.time.length > 5) {
        return moment(value.substr(11), 'HH:mm')
      } else {
        return moment(value, 'HH:mm')
      }
    } else {
      this.forms.time = ''; // если ставить просто '', то пикер удаляется из DOM
    }
  }

  changeDate(date: any): void {
    this.forms.date = date ? date.format('DD.MM.YYYY') : ''; // если ставить просто '', то пикер удаляется из DOM
  }
  changeTime(time: any) {
    this.forms.time = time ? time.format('HH:mm') : ''; // если ставить просто '', то пикер удаляется из DOM
  }

  @ScrollData
  hScroll(source: string, value: {}) {
  }

  handleScroll() {
    this.hScroll('productsStock', { store_id: this.forms.store_id })
  }

  @SearchData
  hSearch(source: string, value: {}) {
  }

  handleSearch(value: string) {
    this.hSearch('productsStock', { name: value, store_id: this.forms.store_id })
  }

  workersSearch(value: any): void {
    this.hSearch("workers", { name: value });
  }

  searchClient(value: any): void {
    this.hSearch('clients', { name: value })
  }

  async storeChange(): Promise<void> {
    this.forms.products = []
    let filter = {
      store_id: this.forms.store_id
    }
    await this.fetchProductStock(filter)
  }

  public deleteProduct(index: number): void {
    this.forms.deleteProduct(index);
  }

  public addProduct(): void {
    const product = new SaleProductData();
    console.log('prod', product)
    this.forms.addProduct(product);
    console.log('form', this.forms)
  }


  selectAndAddProduct() {
    this.tree_keys.forEach((i: any, index: any) => {
      let product = new SaleProductData();
      let productStoreProduct: any = this.productsStocks?.data.find((item: any) => {
        return item.id === i
      })
      product.id = productStoreProduct?.nomenclature?.id
      product.price = productStoreProduct?.nomenclature?.cost_price
      product.total = productStoreProduct?.nomenclature?.cost_price.replace(/\s/g, '')
      this.forms.addProduct(product);
    });
    this.showStockProducts = false;
  }

  async selectProduct(index: any) {
    console.log("selcetProd")
    let price = ProductsStockStore.items?.data.find((item: any) => {
      return item.product_nomenclature_id === this.forms.products![index].id
    })?.cost_price_formated as any
    this.forms.products![index].total = this.forms.products![index].price = price.replace(/\s/g, '')
  }

  onCheck(checkedKeys: any): void {
    console.log("onCheck", checkedKeys)
    this.tree_keys = checkedKeys;
  }

  calculate(index: any) {
    const sum: any = Number(this.forms.products![index].price) * Number(this.forms.products![index].quantity)
    this.forms.products![index].total = sum - Number(this.forms.products![index].quantity) * Number(this.forms.products![index].price) * Number(this.forms.products![index].discount) / 100
  }

  get finalSum() {
    let sum = 0
    this.forms.products!.forEach(item => {
      if (item.quantity) {
        sum += Number(item.total) as any
      } else {
        sum += Number(item.total) * 0 as any
      }
    })
    if (this.t_mod === true) {
      sum = this.operations?.data![0].total_sum as any
      this.t_mod = false
    }
    return sum
  }

  async fetchProductStock(filter: any) {
    await ProductsStockStore.fetchAll({ filter: filter })
  }

  async getData() {
    this.forms.storage_operation_type_id = 1
    if (this.$router.currentRoute.params["id"] !== '0') {
      this.forms.id = 1
      await OperationsStore.fetchAll({ filter: { id: this.$router.currentRoute.params["id"] } });
      this.t_mod = true
      console.error(this.operations?.data)
      for (let i of (this.operations?.data as any)) {
        this.forms.date = i.date
        this.forms.time = i.date.substr(11, 5)
        this.forms.store_id = i.store_id
        i.products.forEach((x: any, index: number) => {
          this.forms.products.push(x) as any
          this.forms.products[index].id = x.product_id
        })
        this.forms.cashbox_id = i.cashbox_id
        this.forms.contractor_id = i.staff_id
        this.forms.client_name = i.client.name
        this.forms.client_phone = i.client.phone
      }
      await this.fetchProductStock({ store_id: this.forms.store_id })
    }
  }

  async created(): Promise<void> {
    console.clear()
    this.tableLoad = false;
    if (!this.formReady) {
      try {
        this.getData()
        await WorkersStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: getStudioId(this) } });
        await StoresStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: getStudioId(this) } });
        await CashboxStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
        await CounterpartiesStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: getStudioId(this) } })
        await ClientsStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: getStudioId(this) } })
      } catch (e) {
        console.log(e);
      } finally {
        this.formReady = true;
      }
    }
  }
}
